class Globals {

    constructor() {

    }

}

export default Globals;
